const axios = require('axios');

const SEARCH_SOURCES = [
  { id: 'all', label: 'Search All' },
  { id: 'youtube', label: 'YouTube' },
  { id: 'vimeo', label: 'Vimeo' },
  { id: 'archiveorg', label: 'Archive.org' },
  { id: 'wikimedia', label: 'Wikimedia' },
  { id: 'peertube', label: 'PeerTube' },
  { id: 'dailymotion', label: 'Dailymotion' },
  { id: 'odysee', label: 'Odysee' },
  { id: 'twitch', label: 'Twitch Clips' },
  { id: 'audius', label: 'Audius (audio)' },
  { id: 'nasa', label: 'NASA' },
  { id: 'pixabay', label: 'Pixabay' },
  { id: 'pexels', label: 'Pexels' },
];

// Convert backend results to exact YouTube API format
// so YoutubeListSection renders them without any changes
function normalizeToYoutubeFormat(items) {
  return items.map((v) => ({
    id: { videoId: v.id || "unknown" },
    snippet: {
      title: v.title || "Untitled",
      description: v.description || "",
      channelTitle: v.channelName || v.source || "",
      channelId: "",
      publishedAt: v.publishedAt || "",
      publishTime: v.publishedAt || "",
      thumbnails: {
        default: { url: v.thumbnail || "" },
        medium: { url: v.thumbnail || "" },
        high: { url: v.thumbnail || "" },
      },
    },
    views: v.views || null,
    likes: v.likes || null,
    duration: v.duration || "PT0S",
    tags: [],
    category: v.source || "",
    _source: v.source || "",
    _embedUrl: v.embedUrl || v.url || "",
    _url: v.url || "",
    _embeded_code: v._embeded_code || v.embedUrl || "",
    _channelUrl: v.channelUrl || "",
  }));
}

async function doUniversalSearch(apiUrl, source, searchText, page) {
  const endpoint = source === "all" ? "all" : source;
  const url = apiUrl + "/search/" + endpoint +
    "?q=" + encodeURIComponent(searchText) +
    "&page=" + page + "&perPage=20";

  const res = await axios.get(url);
  const items = res.data.data || res.data.results || [];
  return normalizeToYoutubeFormat(items);
}

module.exports = { SEARCH_SOURCES, doUniversalSearch };
